import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
let default_1 = class extends Vue {
    get key() {
        return this.$route.path;
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: 'AppMain',
    })
], default_1);
export default default_1;
